import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

export interface WithRouterProps<P = {}> {
  location: ReturnType<typeof useLocation>;
  navigate: ReturnType<typeof useNavigate>;
  params: Readonly<P>;
}

export function withRouter<P extends object, R extends Record<string, string | undefined> = {}>(
  Component: React.ComponentType<P & WithRouterProps<R>>
) {
  return (props: P) => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams<R>();

    return (
      <Component
        {...props}
        location={location}
        navigate={navigate}
        params={params as Readonly<R>}
      />
    );
  };
}